export const state = {
    filterDef: [],
    filterModel: {
        filterType: 'and',
        filterRows: []
    },
    quickSearchFilterDef: {
        placeholder: '',
        fields: []
    },
    quickSearchFilterModel: {
        filterType: 'and',
        filterRows: []
    },
    quickSearchTerm: '',
    filterModelIsDirty: false,
    quickSearchFilterModelIsDirty: false,
    forceClearSearchValue: false,
    appliedAt: null
};

export const reducer = {
    setFilterDef(state, action) {
        if ('filterDef' in (state || {})) {
            state.filterDef = action?.payload;
        }
    },
    setQuickSearchFilterDef(state, action) {
        if ('quickSearchFilterDef' in (state || {})) {
            state.quickSearchFilterDef = action?.payload;
        }
    },
    setFilterModelIsDirty(state, action) {
        if ('filterModelIsDirty' in (state || {})) {
            state.filterModelIsDirty = Boolean(action?.payload);
        }
    },
    setQuickSearchFilterModelIsDirty(state, action) {
        if ('quickSearchFilterModelIsDirty' in (state || {})) {
            state.quickSearchFilterModelIsDirty = Boolean(action?.payload);
        }
    },
    setFilters(state, action) {
        if ('filterModel' in (state || {})) {
            state.filterModel = action?.payload;
        }
        if ('filterModelIsDirty' in (state || {})) {
            state.filterModelIsDirty = Boolean(action?.payload);
        }
        if ('appliedAt' in (state || {})) {
            state.appliedAt = new Date();
        }
    },
    clearFilters(state) {
        if ('filterModel' in (state || {})) {
            state.filterModel = {
                filterType: 'and',
                filterRows: []
            };
        }
        if ('filterModelIsDirty' in (state || {})) {
            state.filterModelIsDirty = false;
        }
    },
    setQuickSearch(state, action) {
        if ('quickSearchFilterModel' in (state || {})) {
            state.quickSearchFilterModel = action?.payload;
        }
        if ('quickSearchFilterModelIsDirty' in (state || {})) {
            state.quickSearchFilterModelIsDirty = true;
        }
        if ('forceClearSearchValue' in (state || {})) {
            state.forceClearSearchValue = false;
        }
        if ('appliedAt' in (state || {})) {
            state.appliedAt = new Date();
        }
    },
    clearQuickSearch(state, action) {
        if ('quickSearchFilterModel' in (state || {})) {
            state.quickSearchFilterModel = {
                filterType: 'and',
                filterRows: []
            };
        }
        if ('quickSearchTerm' in (state || {})) {
            state.quickSearchTerm = '';
        }
        if ('quickSearchFilterModelIsDirty' in (state || {})) {
            state.quickSearchFilterModelIsDirty = false;
        }
        if ('forceClearSearchValue' in (state || {})) {
            const { forceClearSearchValue } = action?.payload || {};
            state.forceClearSearchValue = Boolean(forceClearSearchValue);
        }
    },
    setQuickSearchTerm(state, action) {
        if ('quickSearchTerm' in (state || {})) {
            state.quickSearchTerm = action?.payload;
        }
    },
    setForceClearSearchValue(state, action) {
        if ('forceClearSearchValue' in (state || {})) {
            state.forceClearSearchValue = Boolean(action?.payload);
        }
    }
};
